import { handleJSON } from "@synbioz/ajax";
import parseLinkHeader from "../parseLinkHeader";

const fetchOptions = {
  headers: new Headers({
    "Accept": "application/json",
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
  }),
  credentials: "include"
};

function handleNetworkError(error) {
  if (error instanceof TypeError) {
    throw new Error("Authentication temporarily unavailable, please try again later");
  }
}

/**
 * @param {Object} config
 * @param {String} config.connectedURL
 * @param {String} config.appsURL
 *
 * @return {Object}
 */
export default function getHTTPStrategy({ connectedURL, appsURL }) {
  let links = {};

  /**
   * @param {String} rel
   *
   * @return {String}
   * @throws {Error}
   */
  const getURL = rel => {
    const link = links[rel];

    if (!link) {
      throw new Error(`"${rel}" URL is missing`);
    }

    return link.href;
  };

  return {
    /**
     * @return {Promise}
     */
    getConnectedUser() {
      return fetch(connectedURL, fetchOptions)
        .then(response => {
          links = parseLinkHeader(response.headers.get("Link"));

          return response;
        })
        .then(handleJSON)
        .then(response => response.user)
        .catch(error => {
          handleNetworkError(error);

          if (!("isUnauthorized" in error && error.isUnauthorized())) {
            throw error;
          }
        });
    },

    /**
     * @param {String} email
     * @param {String} password
     *
     * @return {Promise}
     */
    login(email, password) {
      try {
        return fetch(getURL("login"), {
          ...fetchOptions,
          method: "POST",
          body: `user[email]=${encodeURIComponent(email)}&user[password]=${encodeURIComponent(password)}`
        })
          .then(response => Promise.all([response.ok, response.json()]))
          .then(([success, data]) => {
            if (!success) {
              throw new Error(data.error);
            }

            return data.user;
          })
          .catch(error => {
            handleNetworkError(error);

            throw error;
          });
      } catch (error) {
        return Promise.reject(error);
      }
    },

    /**
     * @return {Promise}
     */
    logout() {
      try {
        return fetch(getURL("logout"), fetchOptions);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    /**
     * @return {Array}
     */
    getMockedUsers() {
      return [];
    },

    /**
     * @return {Promise}
     */
    getApps() {
      return fetch(appsURL)
        .then(handleJSON);
    }
  };
}
